import { Reducer } from "redux";

import { ApplicationStatefulModule } from "@multiweb/types/react";
import { NAME } from "./constants";
import { reducer } from "./reducer";
import { saga } from "./saga";
import { IMenuNavigationState } from "./types";

export {
    createActionItemFocusedAction,
    createClearNavigationSectionAction,
    createFocusDefaultItemAction,
    createKeyPressedAction,
    createMenuFocusLostAction,
    createSetFocusedItemAction,
    createSetNavigationNodesAction,
} from "./actions";
export {
    FORM_SEARCH_INPUT_FOCUSABLE_ID,
    LOGO_FOCUSABLE_ID,
    LOGOUT_BUTTON_FOCUSABLE_ID,
    MENU_EXPAND_BUTTON_FOCUSABLE_ID,
    QUICK_ACCESS_FOCUSABLE_ID,
    SET_GROUP_NOTIFICATIONS_AS_READ_BUTTON_FOCUSABLE_ID,
    SETTINGS_BUTTON_FOCUSABLE_ID,
    SHOW_ALL_NOTIFICATIONS_BUTTON_FOCUSABLE_ID,
    TOGGLE_THEME_BUTTON_FOCUSABLE_ID,
    USER_MENU_FOCUSABLE_ID,
} from "./menuNavigationConstants";
export { connectChildrenAndParent } from "./menuNavigationUtils";
export { focusIfNotFocusedSaga, setNavigationNodesForSectionSaga, updateSelectedSectionNavigationSaga } from "./saga";
export {
    getFocusedFormItemIndex,
    getFocusedNotificationIndex,
    getNavigationNode,
    getSelectAllTextInSearchInput,
    isActionItemFocused,
    isFocused,
    isFormItemFocused,
    isItemFocused,
} from "./selectors";
export {
    FocusableItem,
    FocusableItemId,
    FocusableItemType,
    MenuFocusableItemType,
    MenuNavigationSectionType,
    MutableNavigationNode,
    NavigationNode,
    NavigationSection,
} from "./types";
export {
    connectHorizontally,
    connectMultipleHorizontally,
    connectMultipleToEsc,
    connectMultipleToLeftNode,
    connectMultipleVertically,
    connectMultipleVerticallyCyclic,
    connectVertically,
    copyNode,
    createFocusableItemId,
    createMultipleNavigationNodes,
    createNavigationNode,
    getFocusableTypeByOpenMethod,
    searchGroupToNavigationSection,
} from "./utils";

export const navigationModule: ApplicationStatefulModule<typeof NAME, Reducer<IMenuNavigationState>> = {
    NAME,
    reducer,
    saga,
};
